import React from "react"
import PropTypes from "prop-types"

const Offsymbol = props => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: 12,
        color: "#fff",
        paddingRight: 2,
      }}
    >
      {" "}
      {props?.text || ""}
    </div>
  )
}
export default Offsymbol
Offsymbol.propTypes = {
  text: PropTypes.string,
}
